(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
module.exports = logger

var log = []

function logger (label) {

  function contains (searchTerm, subject) {
    return subject.some(function (item) {
      try {
        return item && (JSON.stringify(item).indexOf(searchTerm) !== -1)
      } catch (e) {
        return false
      }
    })
  }

  function allowOutput () {
    return ((typeof global !== 'undefined' && global.debug)
      || (typeof window !== 'undefined' && window.debug))
      && ((typeof window.debug.filter === 'undefined')
        || contains(window.debug.filter, Array.prototype.slice.call(arguments)))
  }

  // Wraps IE9's native console.log as a javascript primitive
  var cout = Function.prototype.bind.call(console.log, console)

  function debug () {

    if (typeof console !== undefined && allowOutput.apply(null, arguments)) {
      var msg = Array.prototype.slice.call(arguments)
      msg.unshift(label + ' »')
      cout.apply(console, msg)
      log.push(msg)
    }
  }

  debug.showLog = function () {
    if (typeof console !== undefined && allowOutput()) {
      cout.apply(console, log)
    }
    return log
  }

  return debug

}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/lib/debug.js","/admin/source/js/app/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFkbWluL3NvdXJjZS9qcy9hcHAvbGliL2RlYnVnLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBIiwiZmlsZSI6ImdlbmVyYXRlZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzQ29udGVudCI6WyJtb2R1bGUuZXhwb3J0cyA9IGxvZ2dlclxuXG52YXIgbG9nID0gW11cblxuZnVuY3Rpb24gbG9nZ2VyIChsYWJlbCkge1xuXG4gIGZ1bmN0aW9uIGNvbnRhaW5zIChzZWFyY2hUZXJtLCBzdWJqZWN0KSB7XG4gICAgcmV0dXJuIHN1YmplY3Quc29tZShmdW5jdGlvbiAoaXRlbSkge1xuICAgICAgdHJ5IHtcbiAgICAgICAgcmV0dXJuIGl0ZW0gJiYgKEpTT04uc3RyaW5naWZ5KGl0ZW0pLmluZGV4T2Yoc2VhcmNoVGVybSkgIT09IC0xKVxuICAgICAgfSBjYXRjaCAoZSkge1xuICAgICAgICByZXR1cm4gZmFsc2VcbiAgICAgIH1cbiAgICB9KVxuICB9XG5cbiAgZnVuY3Rpb24gYWxsb3dPdXRwdXQgKCkge1xuICAgIHJldHVybiAoKHR5cGVvZiBnbG9iYWwgIT09ICd1bmRlZmluZWQnICYmIGdsb2JhbC5kZWJ1ZylcbiAgICAgIHx8ICh0eXBlb2Ygd2luZG93ICE9PSAndW5kZWZpbmVkJyAmJiB3aW5kb3cuZGVidWcpKVxuICAgICAgJiYgKCh0eXBlb2Ygd2luZG93LmRlYnVnLmZpbHRlciA9PT0gJ3VuZGVmaW5lZCcpXG4gICAgICAgIHx8IGNvbnRhaW5zKHdpbmRvdy5kZWJ1Zy5maWx0ZXIsIEFycmF5LnByb3RvdHlwZS5zbGljZS5jYWxsKGFyZ3VtZW50cykpKVxuICB9XG5cbiAgLy8gV3JhcHMgSUU5J3MgbmF0aXZlIGNvbnNvbGUubG9nIGFzIGEgamF2YXNjcmlwdCBwcmltaXRpdmVcbiAgdmFyIGNvdXQgPSBGdW5jdGlvbi5wcm90b3R5cGUuYmluZC5jYWxsKGNvbnNvbGUubG9nLCBjb25zb2xlKVxuXG4gIGZ1bmN0aW9uIGRlYnVnICgpIHtcblxuICAgIGlmICh0eXBlb2YgY29uc29sZSAhPT0gdW5kZWZpbmVkICYmIGFsbG93T3V0cHV0LmFwcGx5KG51bGwsIGFyZ3VtZW50cykpIHtcbiAgICAgIHZhciBtc2cgPSBBcnJheS5wcm90b3R5cGUuc2xpY2UuY2FsbChhcmd1bWVudHMpXG4gICAgICBtc2cudW5zaGlmdChsYWJlbCArICcgwrsnKVxuICAgICAgY291dC5hcHBseShjb25zb2xlLCBtc2cpXG4gICAgICBsb2cucHVzaChtc2cpXG4gICAgfVxuICB9XG5cbiAgZGVidWcuc2hvd0xvZyA9IGZ1bmN0aW9uICgpIHtcbiAgICBpZiAodHlwZW9mIGNvbnNvbGUgIT09IHVuZGVmaW5lZCAmJiBhbGxvd091dHB1dCgpKSB7XG4gICAgICBjb3V0LmFwcGx5KGNvbnNvbGUsIGxvZylcbiAgICB9XG4gICAgcmV0dXJuIGxvZ1xuICB9XG5cbiAgcmV0dXJuIGRlYnVnXG5cbn1cbiJdfQ==